/**
 * 이미지 파일을 WebP로 변환하고 긴 변을 maxDimension 이하로 리사이즈합니다.
 *
 * - 브라우저가 WebP 출력을 지원하지 않는 경우(구형 Safari 등) 원본 파일 반환
 * - HEIC / 브라우저가 읽지 못하는 포맷도 graceful fallback
 *
 * @param {File} file               원본 이미지 파일
 * @param {number} [maxDimension=1600] 긴 변 최대 픽셀
 * @param {number} [quality=0.85]   WebP 품질 (0~1)
 * @returns {Promise<File>} 변환된 File (실패 시 원본 반환)
 */
export async function convertToWebP(file, maxDimension = 1600, quality = 0.85) {
  return new Promise((resolve) => {
    // DataURL 로딩
    const reader = new FileReader();
    reader.onerror = () => resolve(file); // 읽기 실패 → 원본
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = () => resolve(file); // 이미지 파싱 실패 → 원본 (HEIC on Chrome 등)
      img.onload = () => {
        let { width, height } = img;

        // 긴 변 기준 리사이즈
        if (width > maxDimension || height > maxDimension) {
          if (width >= height) {
            height = Math.round((height / width) * maxDimension);
            width  = maxDimension;
          } else {
            width  = Math.round((width / height) * maxDimension);
            height = maxDimension;
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width  = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        if (!ctx) { resolve(file); return; }
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              // WebP 미지원 브라우저(구형 Safari) → 원본 반환
              resolve(file);
              return;
            }
            // 새 파일명: 확장자를 .webp 로 교체
            const baseName = file.name.replace(/\.[^.]+$/, '');
            const converted = new File([blob], `${baseName}.webp`, { type: 'image/webp' });
            resolve(converted);
          },
          'image/webp',
          quality
        );
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}
